import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportSidebar = ({ sections, activeSection, onSectionChange, isCollapsed }) => {
  const handleSectionClick = (index) => {
    onSectionChange(index);
  };

  return (
    <div className={`bg-card border-r border-border transition-all duration-300 ${isCollapsed ? 'w-16' : 'w-64'}`}>
      <div className="sticky top-0 h-screen overflow-y-auto">
        <div className="p-4 border-b border-border">
          {!isCollapsed && (
            <h3 className="font-semibold text-lg">Report Sections</h3>
          )}
        </div>
        
        <nav className="p-2">
          {sections?.map((section, index) => (
            <button
              key={index}
              onClick={() => handleSectionClick(index)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left transition-all duration-200 mb-1 ${
                activeSection === index
                  ? 'bg-primary text-primary-foreground'
                  : 'hover:bg-muted text-foreground'
              }`}
              title={isCollapsed ? section?.title : ''}
            >
              <Icon 
                name={section?.icon} 
                size={20} 
                className="flex-shrink-0"
              />
              {!isCollapsed && (
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{section?.title}</div>
                  {section?.completed && (
                    <Icon name="CheckCircle" size={14} className="inline ml-1" />
                  )}
                </div>
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default ReportSidebar;